import LocomotiveScroll from 'locomotive-scroll';
import imagesLoaded from 'imagesloaded';
document.addEventListener( 'DOMContentLoaded', function () {



const container = document.querySelector("#wrapper");
const scroll = new LocomotiveScroll({
  el: container,
  smooth: true,
  scrollFromAnywhere: true,
});

imagesLoaded(container, { background: true }, function () {
  scroll.update();
});




})





